// removed by extract-text-webpack-plugin
module.exports = {"tab":"TabView__tab___3JLtt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/TabView.css
// module id = 2107
// module chunks = 4